// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"F_TheComp__9ta6i"};